/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_DescriptionInputs */

const en_directory_agents_description = /** @type {(inputs: Directory_Agents_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You shipped it — now let the agent you already trust list it on Seek AI. One command starts the flow: the agent registers your deployed product, you approve it in one click, and it writes the full listing. You get the showcase page and a dofollow backlink.`)
};

const zh_directory_agents_description = /** @type {(inputs: Directory_Agents_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品上线了，接下来的曝光交给 agent。一条命令启动：它注册你已部署的产品，你一键授权，它完成全部 listing 内容。你获得展示页和 dofollow 外链。`)
};

/**
* | output |
* | --- |
* | "You shipped it — now let the agent you already trust list it on Seek AI. One command starts the flow: the agent registers your deployed product, you approve ..." |
*
* @param {Directory_Agents_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_description = /** @type {((inputs?: Directory_Agents_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_description(inputs)
	return zh_directory_agents_description(inputs)
});
export { directory_agents_description as "directory.agents.description" }